import { MapLayer, withLeaflet } from 'react-leaflet'
import L from 'utils/leafletYandexLayer'

class YandexTileLayer extends MapLayer {
  // eslint-disable-next-line class-methods-use-this
  createLeafletElement({ type, options }) {
    return L.yandex(type, options)
  }
}

export default withLeaflet(YandexTileLayer)
